import React, { Component } from 'react'
import PasswordResetFormBase from '../components/PasswordResetFormBase';

export default class PasswordReset extends Component {
  render() {
    return (
      <>
        <h1>Reset your password</h1>
        <PasswordResetFormBase />
      </>
    )
  }
}
